import { Typography } from '@material-ui/core'
import React from 'react'
import LoadingSpinner from './LoadingSpinner'
import useStyles from './styles'

const LoadingScript = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <LoadingSpinner size={32} />
      <Typography>Just a sec...we&apos;re makin&apos; magic</Typography>
    </div>
  )
}

export default LoadingScript
